import BodyErrors from "./types/BodyErrors";

export const STORAGE_KEY = 'cases-portal';

export const NO_TAG_VALUE = 'noTag';
export const NO_TAG_LABEL = 'No tag';
export const NO_COLOR_VALUE = 'noColor';

export const CARD_WIDTH = 300;
export const CARD_HEIGHT = 450;

export const SIDEBAR_WIDTH = 400;
export const ADDITIONAL_TOOLS_WIDTH = 320;

export const MAX_FILE_SIZE = 5368709120;
export const MAX_FILE_NAME_LENGTH = 200;

export const DATA_LIMIT = 10;

export const SUPPORTED_PREVIEW_FILE_FORMATS = ['html', 'txt', 'pdf', 'png', 'jpeg'];
export const FILE_FORMAT_LABELS = {
  'html': 'HTML',
  'txt': 'Text',
  'doc': 'Microsoft Word (doc)',
  'docx': 'Microsoft Word (docx)',
  'pdf': 'PDF',
  'jpeg': 'Image (JPEG)',
  'png': 'Image (PNG)',
  'zip': 'ZIP',
  'audio': 'Audio',
  'video': 'Video',
  'unknown': 'Unknown',
  'custom': 'Custom'
};

export const FONT_FAMILIES = ['Arial', 'Calibri', 'Courier New', 'Helvetica', 'Times New Roman']

export const FONT_SIZES = [
  5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 16, 18,
  20, 22, 24, 26, 28, 36, 48, 72
];

export const TAB_STOP_VALUES = [
  '0.5', '1', '1.5', '2', '2.5', '3', '3.5', '4', '4.5', '5', '5.5', '6', '6.5', '7'
];

export const APP_URL_LABELS = {
  'appURL': 'Case portal home',
  'appURL:case': 'Case link',
  'appURL:case:timeline': 'Case timeline link',
  'appURL:page': 'Page link',
  'appURL:episode': 'Episode link'
};

export const LANGUAGES = {
  en: 'English',
  es: 'Español',
  fr: 'Français'
};

export const PUBLIC_URLS = [
  '/login',
  '/forgot-password',
  '/reset-password',
  '/verification'
];

// Per error handling doc, only `errros` available
export const IGNORE_RESPONSE_ERRORS = {
  401: {
    pathRegExps: [
      new RegExp('POST /api/users/actions/verifyEmail')
    ]
  },
  403: {
    errorTypes: [
      BodyErrors.MfaRequired,
      BodyErrors.AccountRequired,
      BodyErrors.PasswordChangeRequired
    ]
  },
  404: {
    pathRegExps: [
      new RegExp('GET /api/med/hcpcsCodes/.+')
    ]
  },
  409: {
    pathRegExps: [
      new RegExp('PUT /api/episodes/[0-9]'),
      new RegExp('PATCH /api/episodes/[0-9]'),
      new RegExp('DELETE /api/episodes/[0-9]'),
      new RegExp('DELETE /api/episodeAuthors/[0-9]'),
      new RegExp('PUT /api/dms/documents/[0-9]/pages/[0-9]'),
      new RegExp('PATCH /api/dms/documents/[0-9]/pages/[0-9]'),
      new RegExp('DELETE /api/dms/documents/[0-9]/pages/[0-9]'),
      new RegExp('PATCH /api/dms/documents/pages'),
      new RegExp('POST /api/dms/documents/[0-9]/pages/[0-9]/actions/rotate')
    ]
  },
  503: {
    pathRegExps: [
      new RegExp('POST /api/conversations/[a-zA-Z0-9]+')
    ]
  }
};
export const SNACKBAR_RESPONSE_ERRORS = {
  400: {},
  401: {
    errorTypes: [
      BodyErrors.UsernamePasswordInvalid,
      BodyErrors.UserLocked,
      BodyErrors.UserDisabled,
      BodyErrors.AccountDisabled,
      BodyErrors.ChallengeCodeInvalid
    ]
  },
  409: {},
  500: {
    pathRegExps: [
      new RegExp('POST /api/billing/charges')
    ]
  }
};
export const DIALOG_RESPONSE_ERRORS = {
  403: { errorTypes: null },
  404: { errorTypes: null },
  413: { errorTypes: null },
  500: { errorTypes: null }
};














// -------------------------------------
// ToDO
// -------------------------------------

export const CalendarColors = [
  "#666666",
  "#999999",
  "#b71c1c",
  "#F87171",
  "#fb9a99",
  "#fb8072",
  "#8c564b",
  "#D08770",
  "#5f4339",
  "#b15928",
  "#EA580C",
  "#d95f02",
  "#ff7f00",
  "#fdb863",
  "#F59E0B",
  "#a6761d",
  "#EBCB8B",
  "#FBBF24",
  "#e6ab02",
  "#FCD34D",
  "#bcbd22",
  "#a6d854",
  "#84CC16",
  "#3F6212",
  "#A3BE8C",
  "#4daf4a",
  "#4ADE80",
  "#15803D",
  "#16A34A",
  "#34D399",
  "#10B981",
  "#1b9e77",
  "#8dd3c7",
  "#2DD4BF",
  "#14B8A6",
  "#01665e",
  "#8FBCBB",
  "#1c9099",
  "#17becf",
  "#22D3EE",
  "#88C0D0",
  "#34515e",
  "#0EA5E9",
  "#80b1d3",
  "#377eb8",
  "#5E81AC",
  "#60A5FA",
  "#3B82F6",
  "#2563EB",
  "#818CF8",
  "#6366F1",
  "#7570b3",
  "#A78BFA",
  "#5e3c99",
  "#7C3AED",
  "#C084FC",
  "#9333EA",
  "#cab2d6",
  "#984ea3",
  "#D946EF",
  "#E879F9",
  "#C026D3",
  "#B48EAD",
  "#880e4f",
  "#f781bf",
  "#e7298a",
  "#EC4899",
  "#BE185D",
  "#E11D48",
  "#F43F5E",
  "#BF616A"
];
